import { useFormContext } from 'react-hook-form';
import { TextInput } from '@/components/form/TextInput.tsx';
import { TextareaInput } from '@/components/form/TextareaInput.tsx';
import { InsuranceFormData } from '@/features/dashboard/insurances/schemas/insuranceSchema.ts';

const InsuranceForm = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<InsuranceFormData>();

  return (
    <div className="space-y-4">
      <TextInput
        label="Nazwa"
        required
        placeholder="Nazwa ubezpieczenia"
        register={register('name')}
        error={errors.name?.message}
      />
      <TextareaInput
        label="Opis"
        placeholder="Opis ubezpieczenia (opcjonalnie)"
        register={register('description')}
        error={errors.description?.message}
      />
    </div>
  );
};

export default InsuranceForm;
